<template>
  <div class="home">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
    <header style="height: 88px;" id="home">
      <div class="logo-box">
        <!-- <img alt="logo" src="../../public/images/logo1.png" />
        <img alt="logo" src="../../public/images/logo2.png" /> -->
        <img src="../../public/images/logo.jpg" alt="logo" />
        <h1>宠有乐<small><br />私宠出行司机</small></h1>
      </div>
      <div class="nav-box">
        <div :class="['nav-box--item', 'home' === active ? 'active' : '']">
          <a @click="setActive('home')" href="javascript: void(0)">首页</a>
        </div>
        <div :class="['nav-box--item', 'gsjs' === active ? 'active' : '']">
          <a @click="setActive('gsjs')" href="javascript: void(0)">公司介绍</a>
        </div>
        <div :class="['nav-box--item', 'tsfw' === active ? 'active' : '']">
          <a @click="setActive('tsfw')" href="javascript: void(0)">特色服务</a>
        </div>
        <div :class="['nav-box--item', 'zxzx' === active ? 'active' : '']">
          <a @click="setActive('zxzx')" href="javascript: void(0)">咨询中心</a>
        </div>
        <!-- <div :class="['nav-box--item', 'hzhb' === active ? 'active' : '']">
          <a @click="setActive('hzhb')" href="javascript: void(0)">合作伙伴</a>
        </div> -->
        <div class="nav-box--item">
          <a href="javascript: void(0);" @mouseenter="showFloatMask" @mouseleave="hideFloatMask">下载手机版</a>
        </div>
      </div>
    </header>
    <section>
      <div class="section-1">
        <div class="section-1--top">
          <div>
            <img src="../../public/images/img1.png" />
          </div>
          <div>
            <div class="position-box">
              <hr />
              <h2>专注宠物行业</h2>
              <p>解决宠物吃喝玩乐衣食住行</p>
              <hr />
              <button class="know-more" type="button" disabled="disabled">了解更多</button>
              <hr />
            </div>
          </div>
        </div>
        <div class="section-1--bottom">
          <button type="button">&lt;</button>
          <button type="button">&gt;</button>
        </div>
      </div>
      <div class="section-2" id="gsjs">
        <div class="line"></div>
        <div class="section-2--top">
          <div>
            <img src="../../public/images/img2.png" />
          </div>
          <div>
            <h2>关于我们</h2>
            <p>专注宠物出行，解决宠物吃喝玩乐，衣食住行，同时为宠物主提供优质的宠物服务和娱乐于一体的综合产品。</p>
            <button class="know-more" type="button" disabled="disabled">了解更多</button>
            <hr />
          </div>
        </div>
        <div class="section-2--bottom">
          <img src="../../public/images/img3.png" alt />
          <div class="content-box">
            <div>
              <h2>专享接送服务</h2>
              <p>没时间？别担心，出行有我！</p>
            </div>
            <div>
              <button class="know-more" type="button" disabled="disabled">宠物回家</button>
              <button class="know-more" type="button" disabled="disabled">宠物出行</button>
            </div>
          </div>
        </div>
      </div>
      <div class="section-3" id="tsfw">
        <div class="section-3--top">
          <h2>特色服务</h2>
          <h3 class="english-title">service</h3>
          <hr />
        </div>
        <div class="section-3--bottom">
          <div @mouseenter="setHoverStatusOn" @mouseleave="setHoverStatusOff">
            <div class="img-box">
              <img class="ming" src="../../public/images/img4.png" alt />
              <img class="an" src="../../public/images/img5.png" alt />
              <img class="an" src="../../public/images/img6.png" alt />
            </div>
            <h3>保姆司机</h3>
            <div class="tip">
              <p>服务于国内宠物市场，为宠物主提供贴心的宠物接送服务。</p>
            </div>
          </div>
          <div @mouseenter="setHoverStatusOn" @mouseleave="setHoverStatusOff">
            <div class="img-box">
              <img class="ming" src="../../public/images/img4.png" alt />
              <img class="an" src="../../public/images/img5.png" alt />
              <img class="an" src="../../public/images/img6.png" alt />
            </div>
            <h3>商家入驻</h3>
            <div class="tip">
              <p>海量流量、精准营销、深度分析，助力您的宠物服务用品等销量口碑双丰收。</p>
            </div>
          </div>
          <div @mouseenter="setHoverStatusOn" @mouseleave="setHoverStatusOff">
            <div class="img-box">
              <img class="ming" src="../../public/images/img4.png" alt />
              <img class="an" src="../../public/images/img5.png" alt />
              <img class="an" src="../../public/images/img6.png" alt />
            </div>
            <h3>涨姿势</h3>
            <div class="tip">
              <p>记录宠物美好生活，助力宠主养好宠物，让宠物生活美好。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="section-3 section-4" id="zxzx">
        <div class="line"></div>
        <div class="section-3--top">
          <h2>资讯中心</h2>
          <h3 class="english-title">news</h3>
          <hr />
        </div>
        <div class="section-4--bottom">
          <ul>
            <li>
              <div>
                <span class="date">12</span>
                <div>
                  <p class="month">February</p>
                  <p class="year">2020</p>
                </div>
              </div>
              <p>
                关于新型冠状病毒的
                <big>20</big>个真相！
              </p>
              <button type="button" class="know-more" disabled="disabled">了解更多</button>
            </li>
            <li>
              <div>
                <span class="date">24</span>
                <div>
                  <p class="month">October</p>
                  <p class="year">2019</p>
                </div>
              </div>
              <p>秋风凉爽，铲屎的，我们出发海边吧！</p>
              <button type="button" class="know-more" disabled>了解更多</button>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="section-3 section-5" id="hzhb">
        <div class="line"></div>
        <div class="section-3--top">
          <h2>合作伙伴</h2>
          <h3 class="english-title">partner</h3>
          <hr />
        </div>
        <div class="section-5--bottom"> -->
          <!-- <img src="../../public/images/img8.png" alt /> -->
          <!-- <img src="../../public/images/img7.jpg" alt /> -->
          <!-- <img src="../../public/images/img9.png" alt /> -->
        <!-- </div>
      </div> -->
    </section>
    <footer>
      <!-- <img src="../../public/images/img10.png" alt /> -->
      <img src="../../public/images/logo.jpg" alt />
      <div class="nav-box">
        <div :class="['nav-box--item', 'home' === active ? 'active' : '']">
          <a @click="setActive('home')" href="javascript: void(0)">首页</a>
        </div>
        <div :class="['nav-box--item', 'gsjs' === active ? 'active' : '']">
          <a @click="setActive('gsjs')" href="javascript: void(0)">公司介绍</a>
        </div>
        <div :class="['nav-box--item', 'tsfw' === active ? 'active' : '']">
          <a @click="setActive('tsfw')" href="javascript: void(0)">特色服务</a>
        </div>
        <div :class="['nav-box--item', 'zxzx' === active ? 'active' : '']">
          <a @click="setActive('zxzx')" href="javascript: void(0)">咨询中心</a>
        </div>
        <!-- <div :class="['nav-box--item', 'hzhb' === active ? 'active' : '']">
          <a @click="setActive('hzhb')" href="javascript: void(0)">合作伙伴</a>
        </div> -->
        <div class="nav-box--item">
          <a href="javascript: void(0);" @mouseenter="showFloatMask" @mouseleave="hideFloatMask">下载手机版</a>
        </div>
      </div>
      <div>
        <img src="../../public/images/img11.png" alt />
        <p>联系我们</p>
        <p>lyj26262626（微信）</p>
        <div class="gongzhongcode">
          <img src="../../public/images/gongzhong.jpg" alt="宠有乐公众号">
          <p>扫码关注公众号</p>
        </div>
      </div>
      <div class="copyright">
        <a href="http://beian.miit.gov.cn">粤ICP备20002422号 版权所有 &copy; 深圳市宠有乐科技有限公司</a>
      </div>
    </footer>
    <aside :class="['float-mask', { hide: !showFloat }]">
      <div>
        <img src="../../public/images/android.jpg" alt="安卓版" />
        <p>安卓版</p>
      </div>
      <div>
        <img src="../../public/images/ios.png" alt="IOS版" />
        <p>IOS版</p>
      </div>
    </aside>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  data() {
    return {
      active: "home",
      showFloat: false
    };
  },
  methods: {
    setActive(val) {
      this.active = val;
      // window.location.hash = val;
      document.getElementById(val).scrollIntoView();
    },
    setHoverStatusOn(e) {
      e.target.classList.add("active");
    },
    setHoverStatusOff(e) {
      e.target.classList.remove("active");
    },
    showFloatMask() {
      this.showFloat = true;
    },
    hideFloatMask() {
      this.showFloat = false;
    }
  }
};
</script>

<style lang="scss">
.home {
  header {
    width: 100%;
    overflow: hidden;
    & > :nth-child(1) {
      float: left;
      margin-left: 204px;
    }
    & > :nth-child(2) {
      float: right;
      margin-right: 185px;
    }
  }
  .logo-box {
    position: relative;
    margin-top: 25px;
    img {
      height: 52px;
      + img {
        position: absolute;
        top: 31px;
        left: 63px;
        height: 18px;
      }
    }
    h1 {
      margin-left: 3px;
      display: inline-block;
      font-size: 26px;
      line-height: 1em;
    }
    small {
      font-size: 14px;
      line-height: 1em;
    }
  }
  .nav-box {
    margin-top: 42px;
    text-align: center;
  }
  .nav-box--item {
    position: relative;
    display: inline-block;
    padding: 0 20px;
    font-size: 14px;
    a {
      color: #999;
      text-decoration: none;
    }
    &:after {
      content: "";
      display: block;
      position: absolute;
      left: 20px;
      right: 20px;
      bottom: -31px;
      height: 4px;
      background-image: linear-gradient(45deg, #ffb700, #f338e3);
      // background-color: #fedb05;
      transition: bottom 0.3s;
    }
    &.active {
      a {
        color: #707070;
      }
      &:after {
        bottom: -27px;
      }
    }
  }
  .line {
    margin: 0 auto;
    width: 986px;
    height: 1px;
    background-color: #707070;
    opacity: 0.3;
  }
  .know-more {
    margin-bottom: 37px;
    padding: 7px 27px 8px;
    border: 1px solid transparent;
    border-radius: 4px;
    font-size: 12px;
    line-height: 16px;
    background-image: linear-gradient(45deg, #ffb700, #f338e3);
    // background-color: #fedb05;
    color: #fff;
    cursor: pointer;
    &:focus {
      outline: none;
    }
    &[disabled], &.disabled {
      cursor: not-allowed;
    }
  }
  .section-1 {
    .section-1--top {
      display: flex;
      > :nth-child(1) {
        width: 53%;
      }
      > :nth-child(2) {
        position: relative;
        padding-left: 15px;
        color: #707070;
      }
      .position-box {
        position: absolute;
        top: 32%;
      }
      h2 {
        margin-top: 24px;
        font-size: 39px;
        font-weight: bold;
        line-height: 1;
        + p {
          margin-top: 7px;
          font-size: 21px;
          line-height: 31px;
        }
      }
      hr {
        width: 318px;
        height: 0px;
        border-width: 0;
        border-top: 1px solid rgba(112, 112, 112, 1);
      }
      hr:nth-of-type(2) {
        width: 49px;
        margin-top: 25px;
        margin-bottom: 36px;
      }
    }
    img {
      width: 100%;
    }
    .section-1--bottom {
      margin-top: 112px;
      margin-bottom: 101px;
      text-align: center;
      button {
        margin-right: 1px;
        padding: 18px 22px;
        border: 0;
        background-color: #fbfbfb;
        font-size: 24px;
        line-height: 1;
        color: #9d9d9d;
        cursor: pointer;
        &:focus {
          outline: none;
        }
      }
    }
  }
  .section-2 {
    .section-2--top {
      display: flex;
      > div {
        width: 50%;
      }
      > :nth-child(1) {
        padding-right: 30px;
        text-align: right;
      }
      > :nth-child(2) {
        position: relative;
        padding-left: 50px;
        padding-top: 37px;
        color: #707070;
        h2 {
          margin-bottom: 136px;
          font-size: 32px;
          line-height: 1;
        }
        p {
          margin-bottom: 65px;
          width: 343px;
          font-size: 16px;
          line-height: 30px;
        }
        hr {
          position: absolute;
          bottom: 0;
          width: 378px;
          height: 0;
          border: 0;
          border-bottom: 1px solid rgba(112, 112, 112, 0.3);
        }
      }
    }
    .section-2--bottom {
      position: relative;
      margin-top: 104px;
      img {
        width: 100%;
      }
      .content-box {
        position: absolute;
        left: 18%;
        top: 20%;
        color: #707070;
        > div {
          width: 310px;
          padding-top: 36px;
          border-top: 1px solid rgba(112, 112, 112, 0.3);
        }
        h2 {
          margin-bottom: 9px;
          font-size: 30px;
          line-height: 1;
        }
        p {
          margin-bottom: 36px;
          font-size: 18px;
          line-height: 1;
        }
        button + button {
          margin-left: 23px;
        }
      }
    }
  }
  .section-3 {
    .section-3--top {
      padding-top: 94px;
      text-align: center;
      h2 {
        font-size: 32px;
        line-height: 36px;
        font-weight: 500;
        color: #707070;
      }
      h3 {
        margin-top: 10px;
        margin-bottom: 41px;
        font-size: 22px;
        line-height: 1;
        font-weight: normal;
        font-family: "Futura LT Book";
        color: rgba(112, 112, 112, 0.3);
        text-transform: uppercase;
      }
      hr {
        margin: 0 auto;
        width: 199px;
        height: 0;
        border: 0;
        border-bottom: 1px solid rgba(112, 112, 112, 0.3);
      }
    }
    .section-3--bottom {
      width: 986px;
      margin: 0 auto;
      padding-top: 101px;
      display: flex;
      h3 {
        margin: 46px 0 33px;
        font-size: 20px;
        line-height: 1;
      }
      > div {
        flex: 1 0 0;
        width: 0;
        padding: 67px 40px 63px;
        text-align: center;
        color: #707070;
        transition: background-color 0.5s;
        .img-box {
          position: relative;
          img:nth-of-type(3) {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .tip {
          padding: 21px 0 30px;
          border-width: 1px 0;
          border-color: #888888;
          border-style: solid;
          font-size: 14px;
          line-height: 24px;
        }
        .ming {
          display: none;
        }
        .an {
          display: inline-block;
        }
      }
      .active {
        // background-color: #fedb05;
        background-image: linear-gradient(45deg, #ffb700, #f338e3);
        color: #fff;
        .ming {
          display: inline-block;
        }
        .an {
          display: none;
        }
        .tip {
          border-color: #fff;
        }
      }
    }
  }
  .section-4 {
    .section-4--bottom {
      margin: 0 auto;
      width: 986px;
      ul {
        padding-top: 89px;
        padding-bottom: 102px;
      }
      li {
        display: flex;
        align-items: center;
        background-color: #fbfbfb;
        > div {
          width: 96px;
          position: relative;
          display: flex;
          padding: 52px 20px 46px;
          // background-color: #fedb05;
          background-image: linear-gradient(45deg, #ffb700, #f338e3);
          color: #fff;
          &:after {
            position: absolute;
            left: 100%;
            content: "";
            display: block;
            width: 0;
            height: 0;
            border-width: 20px 0 20px 20px;
            border-style: solid;
            border-color: transparent transparent transparent #f65ca2;
          }
        }
        > p {
          flex-grow: 1;
          padding-left: 86px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          color: #707070;
        }
        big {
          font-size: 2em;
        }
        > button {
          flex-shrink: 0;
          margin-right: 50px;
          margin-bottom: 0;
        }
        + li {
          margin-top: 40px;
        }
      }
      .date {
        margin-right: 4px;
        font-size: 41px;
        line-height: 1;
      }
      .month,
      .year {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
  .section-5 {
    .section-5--bottom {
      margin: 0 auto;
      padding: 42px 0 80px;
      width: 986px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-height: 229px;
        margin: 0 24px;
      }
    }
  }
  footer {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 67px 205px 80px 204px;
    background-color: #474747;
    .img {
      width: 155px;
      height: 64px;
    }
    .nav-box {
      flex-grow: 1;
      margin: 0;
      padding-top: 8px;
    }
    .nav-box--item {
      margin-bottom: 4px;
      a {
        color: #c8c5c8;
      }
      &.active a {
        color: #fff;
      }
    }
    .nav-box--item:after {
      display: none;
    }
    > div:nth-of-type(2) {
      position: relative;
      > img {
        margin-bottom: 67px;
      }
      p {
        color: #fff;
        font-size: 14px;
        line-height: 20px;
        + p {
          margin-top: 20px;
        }
      }
    }
    .gongzhongcode {
      position: absolute;
      top: 46px;
      left: 185px;
      text-align: center;

      img {
        width: 98px;
        height: 98px;
      }
    }
    .copyright {
      width: 100%;
      margin-top: 10px;
      text-align: center;
      font-size: 12px;
      a {
        text-decoration: none;
        color: #fff;
      }
    }
  }

  // 右侧悬浮层
  .float-mask {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    width: 100px;
    flex-wrap: wrap;
    align-content: center;
    box-shadow: 0 0 5px rgba(#000000, 0.8);
    background-color: #fff;
    z-index: inherit;
    opacity: 1;
    transition: all .3s ease-out;
    > div {
      margin: 15px 0;
      width: 100%;
      text-align: center;
    }
    img {
      width: 90px;
      height: 90px;
    }
    &.hide {
      opacity: 0;
      right: -100px;
    }
  }
}
</style>
